import React, { useState } from 'react'
import { useTheme } from 'styled-components'
import { useTranslation } from 'react-i18next'
import * as DropdownMenu from '@radix-ui/react-dropdown-menu'
import { MaterialIcon, Pill } from '@dsny/dsny-component-library'
import { Language } from '@dsny/dsny-component-library/icons'
import styles from '../Dropdowns.module.scss'
import {
  DropdownTrigger,
  LanguageWrapper,
  LanguageIcon
} from './LanguageDropdown.styles'

const LanguageDropdown = ({ languageOptions }) => {
  const theme = useTheme()
  const { t, i18n } = useTranslation()
  const [selectedLanguage, setSelectedLanguage] = useState('English')

  const handleLanguageChange = (languageValue, languageName) => {
    i18n.changeLanguage(languageValue)
    setSelectedLanguage(languageName)
  }

  return (
    <LanguageWrapper>
      <LanguageIcon>
        <Language style={{ color: '#C9C9C9' }} />
      </LanguageIcon>
      <DropdownMenu.Root>
        <DropdownTrigger
          style={{
            justifySelf: 'center',
            border: 'none'
          }}
          onClick={(e) => handleLanguageOptions(e)}
        >
          <Pill
            variant="dark"
            mode="dark"
            label={selectedLanguage}
            iconPosition="tailing"
            icon={
              <MaterialIcon
                name="KeyboardArrowDown"
                color={theme.colors.white0}
                style={{ fontSize: 14 }}
              />
            }
          />
        </DropdownTrigger>

        <DropdownMenu.Portal>
          <DropdownMenu.Content
            side="bottom"
            align="end"
            style={{
              background: theme.colors.neutralW20,
              color: theme.colors.neutralW100,
              padding: '5px 0',
              height: 'auto',
              maxHeight: 216,
              overflow: 'auto',
              border: `0.5px solid ${theme.colors.neutralW30}`
            }}
            className={`${styles.DropdownMenuContent} , ${styles.MenuContent}`}
            sideOffset={5}
            avoidCollisions
            collisionPadding={20}
          >
            {languageOptions.map(
              (option) =>
                (option.props.value !== 'en' ||
                  selectedLanguage !== 'English') && (
                  <DropdownMenu.Item
                    key={option.props.value}
                    className={styles.DropdownMenuItem}
                    onClick={() =>
                      handleLanguageChange(
                        option.props.value,
                        option.props.children
                      )
                    }
                  >
                    {option.props.children}
                  </DropdownMenu.Item>
                )
            )}
          </DropdownMenu.Content>
        </DropdownMenu.Portal>
      </DropdownMenu.Root>
    </LanguageWrapper>
  )
}

export default LanguageDropdown
